import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Space, Switch } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import { column_group } from '../../../components/AdminUserModal/UserInfoTabs/column_coingroup'
import { column_ovs } from '../../../components/AdminUserModal/UserInfoTabs/column_ovs'
import { column_pairs } from '../../../components/AdminUserModal/UserInfoTabs/column_pairs'
import TableAPI from '../../../components/TableAPI'

const CoinPairs = ({ title, type }: any) => {
	const [search, setSearch] = React.useState<any>('')
	const [isall, setIsall] = React.useState<any>(0)

	const [manange, setManage] = React.useState<any>(false)
	return (
		<View style={{ width: '100%' }}>
			<TableAPI
				title={title}
				columns={column_group}
				usermodal={true}
				height={'default'}
				apikey={`/admin/coingroup?${
					search ? 'type=user_id&searchWord=' + search : 't='
				}`}
			/>
			<TableAPI
				title={title}
				columns={column_pairs}
				calender={true}
				extra={
					<>
						<Space.Compact>
							전체보기
							<Switch
								checked={isall}
								onChange={e => setIsall(e ? 1 : 0)}
							/>
						</Space.Compact>
						<Space.Compact>
							<Button onClick={() => setManage(!manange)}>
								종목관리
							</Button>
						</Space.Compact>
					</>
				}
				usermodal={false}
				height={false}
				apikey={`/admin/exchangepairs?ov=1&${isall ? `dev=${1}&` : ''}${
					search ? 'type=user_id&searchWord=' + search : 't='
				}`}
				sharemutate={`/admin/ovs?${
					search ? 'type=symbol&searchWord=' + search : 't='
				}`}
			/>
			{manange && (
				<Modal
					title="종목관리"
					width={'100%'}
					open={manange}
					footer={null}
					onCancel={() => setManage(false)}>
					<Space.Compact
						direction="horizontal"
						style={{
							marginTop: 10,
							backgroundColor: '#fff',
							padding: 10,
							width: '100%',
						}}>
						<Input
							placeholder="검색 (구분, 구분이름, 종목코드, 거래소)"
							value={search}
							onChange={e => {
								setSearch(e.target.value)
							}}
						/>
						<Button
							onClick={() => {
								setSearch('')
							}}
							style={{ paddingTop: 0 }}
							size="small">
							{search ? <CloseOutlined /> : <SearchOutlined />}
						</Button>
					</Space.Compact>
					<TableAPI
						title={'해선종목관리'}
						columns={column_ovs}
						usermodal={false}
						height={false}
						apikey={`/admin/ovs?${
							search ? 'type=symbol&searchWord=' + search : 't='
						}`}
						sharemutate={`/admin/exchangepairs?ov=1&${
							search ? 'type=user_id&searchWord=' + search : 't='
						}`}
					/>
				</Modal>
			)}
		</View>
	)
}

export default React.memo(CoinPairs)
